function reasonViewerTopic(reason) {
  const result = [];
  Object.keys(reason.topics || {}).forEach(topicId => {
    result.push({path: `topics.[${topicId}]`, value: "N/A"});
  });
  return result;
}

export default reasonViewerTopic;
